// @ts-check

/**
 * Incomes module stores the income type entries on the
 * incomes page
 */

import { api } from '@/api'
import { downloadInvoice } from '@/api/invoice'
import { downloadFile } from '@/helpers/functions'
import {
  baseGetters,
  baseMutations,
  createBaseActions,
  createBaseState
} from '@/store/modules/entries/base'

const baseActions = createBaseActions({
  entryType: 'incomes'
})

const initIncomeState = () => ({
  ...createBaseState()
})

const incomeMutations = {
  ...baseMutations,
  clearAllData: (state) => {
    Object.assign(state, createBaseState())
  }
}

const incomeGetters = {
  ...baseGetters
}

/** @type {import('vuex').ActionTree<*, *>} */
export const incomeActions = {
  ...baseActions,
  async downloadInvoice({ rootGetters }, id) {
    const data = await downloadInvoice(id)

    downloadFile(
      data.file,
      `Lasku ${data.invoice_number}`,
      data.mime_type,
      rootGetters['mobileData/isMobileWrapperUser']
    )
  },
  markAsPaid({ commit }, { id, payload }) {
    return api
      .patch(`/incomes/${id}/mark-as-paid`, {
        paid_date: payload.date,
        amount: payload.amount
      })
      .then(({ data }) => {
        commit('updateEntry', { id, data })
      })
  },

  linkBankTransactionsToEntry({ commit }, { id, payload }) {
    const { bankTransactions } = payload
    const { amount } = payload

    if (amount && bankTransactions.length === 1) {
      bankTransactions[0].amount = amount
    }

    return api
      .put(`incomes/link`, {
        bank_transactions: bankTransactions,
        entry_id: id
      })
      .then(({ data }) => {
        commit('updateEntry', { id, data })
      })
  }
}

export const incomeModule = {
  namespaced: true,
  state: initIncomeState,
  getters: incomeGetters,
  mutations: incomeMutations,
  actions: incomeActions
}

export default incomeModule
